// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3FQe0RG79V1M0ue3wRAIVy {\r\n    display: grid;\r\n    \r\n    grid-gap: 24px;\r\n    width: 100%;\r\n}", ""]);
// Exports
exports.locals = {
	"container": "_3FQe0RG79V1M0ue3wRAIVy"
};
module.exports = exports;
